import React from 'react';
import {
  Box,
  Paper,
  TextField,
  InputAdornment,
  Alert,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PageHeader from '../Layout/PageHeader';
import { surfaceCardSx, tokens } from '../../theme/tokens';

/**
 * Shared layout for admin list pages.
 * Provides consistent title, search, actions, error display, and content area.
 */
export default function ListPageLayout({
  title,
  crumbs,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  actions,
  filters,
  error,
  onErrorClose,
  success,
  onSuccessClose,
  children,
}) {
  return (
    <Box>
      <PageHeader title={title} crumbs={crumbs} actions={actions} />

      {(searchPlaceholder != null || filters) && (
        <Paper
          elevation={0}
          sx={{
            ...surfaceCardSx,
            p: 0,
            mb: 2,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 1.25,
              flexWrap: 'wrap',
              alignItems: 'center',
              px: 2.5,
              py: 1.75,
            }}
          >
            {searchPlaceholder != null && (
              <TextField
                placeholder={searchPlaceholder}
                value={searchValue || ''}
                onChange={(e) => onSearchChange?.(e.target.value)}
                size="small"
                sx={{
                  minWidth: 220,
                  flex: 1,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    bgcolor: tokens.surface,
                    '& fieldset': { borderColor: tokens.border },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" sx={{ color: tokens.muted }} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {filters}
          </Box>
        </Paper>
      )}

      {error && (
        <Alert
          severity="error"
          sx={{
            mb: 2,
            borderRadius: '9px',
            bgcolor: tokens.dangerSoft,
            color: '#7C2E1D',
            border: '1px solid #EFCFC5',
          }}
          onClose={onErrorClose}
        >
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: '9px' }} onClose={onSuccessClose}>
          {success}
        </Alert>
      )}

      {children}
    </Box>
  );
}
